import { render, staticRenderFns } from "./Panel.vue?vue&type=template&id=b9aafdd0&scoped=true"
import script from "./Panel.vue?vue&type=script&lang=js"
export * from "./Panel.vue?vue&type=script&lang=js"
import style0 from "./Panel.vue?vue&type=style&index=0&id=b9aafdd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9aafdd0",
  null
  
)

export default component.exports